/**
 * List of company types for use in dropdowns or selection fields.
 * These values directly correspond to the types of companies listed in our ES indices.
 *
 * These are orederd in a way that makes sense for users selecting company types.
 * Do not order them alphabetically.
 */
export const COMPANY_TYPES = [
  {
    value: 'Owner/Developer',
    label: 'Owner/Developer',
  },
  {
    value: 'Architect/Design',
    label: 'Architect/Design',
  },
  {
    value: 'Engineer',
    label: 'Engineer',
  },
  {
    value: 'Consultant',
    label: 'Consultant',
  },
  {
    value: 'General Contractor',
    label: 'General Contractor',
  },
  {
    value: 'Subcontractor',
    label: 'Subcontractor',
  },
  {
    value: 'Supplier/Manufacturer',
    label: 'Supplier/Manufacturer',
  },
];
